import { useEffect, useState } from "react";
import { fetchEnergyProductivityMockSeries, isSupportedEnergyProductivityMetric } from "./EnergyProductivity.mockData";
const INITIAL_STATE = { series: null, status: "loading" };
/**
 * Fetches the Energy &amp; Productivity chart series for the active selection.
 * Returns `unsupported` for metrics without mock data yet, surfaces a loading
 * state during the in-flight call, and guards against stale responses by
 * comparing the returned series to the live selection before committing it to
 * state.
 */
export const useEnergyProductivityData = ({ assetFilter, dateKey, metric }) => {
    const [state, setState] = useState(INITIAL_STATE);
    useEffect(() => {
        if (!isSupportedEnergyProductivityMetric(metric)) {
            setState({ series: null, status: "unsupported" });
            return undefined;
        }
        if (!dateKey) {
            // Invalid date — treat as a transient loading state so callers can
            // render their own messaging via the explicit invalid-date branch.
            setState({ series: null, status: "loading" });
            return undefined;
        }
        let cancelled = false;
        setState((current) => ({ series: current.series, status: "loading" }));
        fetchEnergyProductivityMockSeries(metric, assetFilter, dateKey)
            .then((series) => {
            if (cancelled)
                return;
            // Only commit if the response still matches the live selection.
            if (series.metric !== metric || series.assetFilter !== assetFilter || series.dateKey !== dateKey) {
                return;
            }
            setState({ series, status: "success" });
        })
            .catch(() => {
            if (cancelled)
                return;
            setState({ series: null, status: "error" });
        });
        return () => {
            cancelled = true;
        };
    }, [assetFilter, dateKey, metric]);
    return state;
};
